module.exports = __webpack_public_path__ + "566e6f3dcb4c6b5a1c3d8b5808fbbb3f.pdf";